var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.043,
    height: 32.953,
    viewBox: "0 0 33.043 32.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.473,
    y1: -0.012,
    x2: 0.507,
    y2: 1.162,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59afe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#646ce7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7103",
    "data-name": "Path 7103",
    d: "M41.875,19.162q3.318,2.571,6.641,5.136c.051.039.12.064.122.145-.017.033-.033.065-.049.1q-1.394,2.9-2.789,5.815c-.065.136-.1.221-.273.086q-3.239-2.513-6.487-5.012c-.315-.244-.264-.17-.11-.489l2.736-5.7C41.714,19.141,41.733,19.051,41.875,19.162Zm-3.738,7.511.125.1,5.216,4.02c.435.337.862.691,1.315,1.007.2.145.2.251.1.449-.466.952-.919,1.91-1.378,2.867q-1.444,3-2.887,6.011-1.52,3.166-3.048,6.33-1.052,2.19-2.1,4.384c-.081.171-.132.224-.316.081q-3.255-2.529-6.532-5.034a.24.24,0,0,1-.09-.357q1.289-2.654,2.559-5.317L35.6,31.869q1.208-2.52,2.423-5.039C38.05,26.772,38.065,26.7,38.137,26.672Zm11.835.569L61.546,52.064c-.4-.206-.745-.385-1.092-.568l-6.375-3.369-8.207-4.336q-1.463-.772-2.928-1.539c-.126-.067-.145-.113-.08-.244q2.468-5.139,4.922-10.28,1.028-2.147,2.063-4.292A.435.435,0,0,1,49.972,27.241Z",
    transform: "translate(-28.503 -19.111)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91a2194709c913050967017a3ef7f000.svg";
export { ForwardRef as ReactComponent };